module.exports = __webpack_public_path__ + "img/zanwujilu@2x.11d653ee.png";